
	export default {
		data() {
			return {
				courses: false
			}
		},
		async fetch(){
			const ids = [], currentTime = new Date().getTime()
			for(let i = 0; i < this.$parent.config.courseGrids.length; i++)
				for(let j = 0; j < this.$parent.config.courseGrids[i].courses.length; j++)
					ids.push(this.$parent.config.courseGrids[i].courses[j])
			const tempCourses = await this.$course.getHomepageCourses(ids)
			for(let i = 0; i < tempCourses.length; i++){
				if(tempCourses[i].release_date){
					let diff = currentTime - new Date(tempCourses[i].release_date).getTime()
					diff = diff / (1000 * 60 * 60 * 24)
					if(diff < 60) tempCourses[i].new = true
				}
			}
			this.courses = tempCourses
		}
	}
